module.exports = require("superagent");


/*****************
 ** WEBPACK FOOTER
 ** external "superagent"
 ** module id = 7
 ** module chunks = 0
 **/